// import GuideBoard from 'components/GuideBoard/GuideBoard';
import LoadingImage from 'components/LoadingImage';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setPanoData, setTourData } from 'store/actions';
import { loadTourJson } from 'utils/apiHelper';

const tourId = 'e-town';

export const Layout = ({ children, className = '' }) => {
  const dispatch = useDispatch();
  const [isApiLoaded, setIsApiLoaded] = useState(false);

  useEffect(() => {
    const handleGetTour = async () => {
      const { json, tour } = await loadTourJson(tourId);

      dispatch(setPanoData(json));
      dispatch(setTourData(tour));

      setIsApiLoaded(true);
    };

    handleGetTour();
  }, [dispatch]);

  return (
    <>
      <div
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
        className={`layout ${className}`}
      >
        <LoadingImage
          isApiLoaded={isApiLoaded}
          onStarted={() => {
            // after 3s from loading start, show guide board behind loading
            // dispatch(setGuideBoardVisible(true));
          }}
        />
        {isApiLoaded && (
          <>
            <div
              className="layout-content"
              style={{ display: 'flex', flex: 1, position: 'relative' }}
            >
              {children}
            </div>
          </>
        )}
      </div>

      {/* <GuideBoard /> */}
    </>
  );
};
